import type { MapVehicle, VehicleSource } from '@/types'

interface VehicleSnapshotOptions {
  vehicles: MapVehicle[]
  isPending: boolean
  hasError: boolean
}

export interface VehicleSnapshot {
  vehicles: MapVehicle[]
  source: VehicleSource
}

export function resolveVehicleSnapshot({
  vehicles,
  isPending,
  hasError,
}: VehicleSnapshotOptions): VehicleSnapshot {
  if (hasError && vehicles.length > 0) {
    return {
      source: 'last-known',
      vehicles: vehicles.map((vehicle) => ({ ...vehicle, source: 'last-known' })),
    }
  }

  if (isPending) return { source: 'checking', vehicles: [] }
  if (vehicles.length > 0) return { source: 'live', vehicles }
  return { source: 'unavailable', vehicles: [] }
}
